import { Loc } from 'main.core';
import { NoticeBase } from 'b24network.vue.cross-scenario-shared-js';
import { LoginValidator } from 'b24network.vue.cross-scenario-shared-js';

/**
 * An admin hasn't confirmed yet user invited by a link
 */
export class InviteNotConfirmedByAdmin extends NoticeBase
{
	constructor(userLogin: string)
	{
		const messageText = LoginValidator.isEmailLogin(userLogin)
			? Loc.getMessage(
				'EXT_B24NET_LOGGING_IN_ADMIN_NOT_CONFIRMED_INVITE_EMAIL',
				{
					'[b]': '<b>',
					'[/b]': '</b>',
					'[br]': '<br>',
					'#USER_EMAIL#': userLogin,
				},
			)
			: Loc.getMessage(
				'EXT_B24NET_LOGGING_IN_ADMIN_NOT_CONFIRMED_INVITE_PHONE',
				{
					'[br]': '<br>',
				},
			)
		;

		super(
			messageText,
			Loc.getMessage('EXT_B24NET_LOGGING_IN_ALMOST_READY'),
		);
	}
}
